module.exports = "<ng-content>\r\n</ng-content>\r\n"